/* Weekend Redneck - header interactions */
(function () {
  'use strict';

  var header = document.querySelector('[data-header]');
  if (!header) return;

  /* Header scrolls away with the page (per design), so no solid-on-scroll state. */

  /* ---- Desktop mega menu ----
     Opens on hover and keyboard focus (is-open class drives CSS), closes on
     Escape, on leaving the item, or on focus leaving it. */
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var items = Array.prototype.slice.call(header.querySelectorAll('[data-nav-item].has-panel'));
  var closeTimer = null;

  function setOpen(item, open) {
    var trigger = item.querySelector('[data-panel-trigger]');
    item.classList.toggle('is-open', open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    var anyOpen = items.some(function (i) {
      return i.classList.contains('is-open');
    });
    header.classList.toggle('header--open', anyOpen);
  }

  function closeAllPanels(except) {
    items.forEach(function (item) {
      if (item !== except) setOpen(item, false);
    });
  }

  function openPanel(item) {
    window.clearTimeout(closeTimer);
    closeAllPanels(item);
    setOpen(item, true);
  }

  function closePanelSoon(item) {
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      setOpen(item, false);
    }, 120);
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('[data-panel-trigger]');
    var panel = item.querySelector('[data-panel]');
    if (!trigger || !panel) return;

    if (canHover) {
      item.addEventListener('mouseenter', function () {
        openPanel(item);
      });
      item.addEventListener('mouseleave', function () {
        closePanelSoon(item);
      });
    } else {
      /* Touch / coarse pointer: first tap opens, second navigates */
      trigger.addEventListener('click', function (e) {
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          openPanel(item);
        }
      });
    }

    /* Keyboard focus opens too; focus leaving the item closes it */
    item.addEventListener('focusin', function () {
      if (item.querySelector(':focus-visible')) openPanel(item);
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) closePanelSoon(item);
    });
  });

  /* Escape closes any open panel and returns focus to its trigger */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    items.forEach(function (item) {
      if (!item.classList.contains('is-open')) return;
      var trigger = item.querySelector('[data-panel-trigger]');
      var hadFocus = item.contains(document.activeElement);
      setOpen(item, false);
      if (hadFocus && trigger) trigger.focus();
    });
  });
  if (!canHover) {
    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAllPanels(null);
    });
  }

  /* ---- Dialog helpers (drawer + search) ---- */
  function wireDialog(dialog, openSelector, closeSelector, onOpen) {
    if (!dialog) return;
    var openers = document.querySelectorAll(openSelector);
    var lastOpener = null;
    Array.prototype.forEach.call(openers, function (btn) {
      btn.addEventListener('click', function () {
        lastOpener = btn;
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        btn.setAttribute('aria-expanded', 'true');
        if (onOpen) onOpen();
      });
    });
    dialog.querySelectorAll(closeSelector).forEach(function (btn) {
      btn.addEventListener('click', function () {
        dialog.close();
      });
    });
    /* Close when clicking the backdrop */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () {
      /* Native dialogs restore focus to the opener; cover browsers/paths that do not */
      if (lastOpener && document.contains(lastOpener) && document.activeElement === document.body) {
        lastOpener.focus();
      }
      Array.prototype.forEach.call(openers, function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  var drawer = document.querySelector('[data-drawer]');
  wireDialog(drawer, '[data-drawer-open]', '[data-drawer-close]', function () {
    /* Land on the close button, not the logo link, so Escape/Enter has an obvious target */
    var closeBtn = drawer.querySelector('[data-drawer-close]');
    if (closeBtn) closeBtn.focus();
  });
  /* Drawer left open while the viewport grows to desktop would trap the page */
  if (drawer) {
    window.matchMedia('(min-width: 991px)').addEventListener('change', function (e) {
      if (e.matches && drawer.open) drawer.close();
    });
  }
  /* Close drawer when a nav link is followed */
  if (drawer) {
    drawer.querySelectorAll('a[href]').forEach(function (a) {
      a.addEventListener('click', function () {
        drawer.close();
      });
    });
  }

  /* ---- Drawer accordion ---- */
  if (drawer) {
    drawer.querySelectorAll('[data-acc]').forEach(function (acc) {
      var btn = acc.querySelector('[data-acc-btn]');
      var panel = acc.querySelector('[data-acc-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });
  }

  var search = document.querySelector('[data-search]');
  wireDialog(search, '[data-search-open]', '[data-search-close]', function () {
    var input = search.querySelector('[data-search-input]');
    if (input) {
      window.requestAnimationFrame(function () {
        input.focus();
      });
    }
  });
})();
